import React, { memo } from 'react';
import { NgBootstrap } from './loaders';

export const NgCustomerProfileApp = memo(() => {
  //@ts-ignore
  return <NgBootstrap entrypoint={() => import('../../../src/OCS.Web/wwwroot/app/customerProfileApp')} />;
});
